var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024.95 255.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f9a738;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.69,81H162.61a2.85,2.85,0,0,0-2.85,2.85v46c0,14.08-7.87,20.63-24.78,20.63s-24.79-6.55-24.79-20.63v-46A2.84,2.84,0,0,0,107.34,81H81.58a2.84,2.84,0,0,0-2.84,2.85v48.83c0,28.31,19.54,43.9,55,43.9,35.32,0,54.77-15.59,54.77-43.9V83.82A2.85,2.85,0,0,0,185.69,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.17,81h-25a2.85,2.85,0,0,0-2.85,2.85v45.77L238.12,81.93A2.84,2.84,0,0,0,236,81H200a2.84,2.84,0,0,0-2.85,2.85v88.27a2.84,2.84,0,0,0,2.85,2.85h25a2.85,2.85,0,0,0,2.85-2.85V114.52L280.54,174a2.87,2.87,0,0,0,2.14,1h25.49a2.85,2.85,0,0,0,2.85-2.85V83.82A2.85,2.85,0,0,0,308.17,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.23,125.52c8.62-5.4,9.71-14.23,9.71-18.36,0-17.38-13.59-26.19-40.41-26.19H323.45a2.84,2.84,0,0,0-2.84,2.85v88.27a2.84,2.84,0,0,0,2.84,2.85h58.09c29.22,0,42.83-9.13,42.83-28.74C424.37,138.61,420.51,129.94,410.23,125.52Zm-58.17,12h28.81c8.38,0,13.39,2.4,13.39,6.41,0,2.9,0,7.75-13.92,7.75H352.06Zm28.14-20.72H352.06V104.38h26.53c8.79,0,13.25,2.06,13.25,6.13C391.84,112.55,391.84,116.79,380.2,116.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.65,93.58c-10.67-9.31-26.5-14.22-45.79-14.22s-35.11,4.91-45.79,14.22c-9.68,8.43-15,20.5-15,34,0,30.68,22.73,49,60.8,49s60.81-18.32,60.81-49C549.67,114.08,544.34,102,534.65,93.58ZM488.86,151.8c-18.06,0-28-8.56-28-24.11,0-17.39,14.46-23.58,28-23.58s28,6.19,28,23.58C516.87,143.24,506.92,151.8,488.86,151.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M625.29,127.15l38.45-41.39A2.85,2.85,0,0,0,661.65,81H631.87a2.82,2.82,0,0,0-2.17,1L607,108.61l-24.12-26.7a2.85,2.85,0,0,0-2.12-.94H547.48a2.85,2.85,0,0,0-2.06,4.81l38.42,40.48L544,170.18a2.85,2.85,0,0,0,2.11,4.76h30.72a2.83,2.83,0,0,0,2.2-1l23.62-28.65L627.57,174a2.86,2.86,0,0,0,2.15,1H663a2.85,2.85,0,0,0,2.09-4.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 671.14,
    y: 80.97,
    width: 31.46,
    height: 93.97,
    rx: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M823.84,81h-25A2.85,2.85,0,0,0,796,83.82v45.76L753.79,81.93a2.84,2.84,0,0,0-2.13-1H715.71a2.84,2.84,0,0,0-2.85,2.85v88.27a2.84,2.84,0,0,0,2.85,2.85h24.95a2.85,2.85,0,0,0,2.85-2.85V114.52L796.21,174a2.86,2.86,0,0,0,2.14,1h25.49a2.84,2.84,0,0,0,2.84-2.85V83.82A2.84,2.84,0,0,0,823.84,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M943.36,123.63h-54.2a2.86,2.86,0,0,0-2.85,2.85v13.68a2.85,2.85,0,0,0,2.85,2.85h25.18c-1.63,4.91-8.13,10.81-22.09,10.81-10,0-26.8-3.19-26.8-24.52,0-15.78,10.17-25.19,27.2-25.19,16.29,0,23.58,6.31,23.58,12.58v.93a2.85,2.85,0,0,0,2.85,2.85H942a2.84,2.84,0,0,0,2.82-2.44,14.84,14.84,0,0,0,.16-2.28c0-10.94-5.18-36.39-53.15-36.39-43.15,0-58.53,25.73-58.53,49.8,0,11.12,3.94,47.39,54.64,47.39,17.6,0,27.43-5,32.86-11.16-.05,2.65-.1,5-.16,6.6a2.81,2.81,0,0,0,.8,2.08,2.84,2.84,0,0,0,2,.87h19.85a2.84,2.84,0,0,0,2.85-2.85V126.48A2.85,2.85,0,0,0,943.36,123.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "973.43 52.59 51.9 52.59 30.38 0 994.92 0 973.43 52.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.86 203.32 973.43 203.32 994.95 255.91 30.38 255.91 51.86 203.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1024.95 229.93 973.43 205.68 973.43 46.29 1024.95 26.29 1024.95 229.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 26.29 51.51 50.54 51.51 209.93 0 229.93 0 26.29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77d565ed5eec1d7f176bfbe4e509f273.svg";
export { ForwardRef as ReactComponent };